import React from 'react';
import { motion } from 'framer-motion';
import { CircleIcon, CalendarIcon, ClockIcon } from 'lucide-react';
export function Hero() {
  return <section className="w-full bg-navy relative overflow-hidden" data-id="element-26">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy via-[#1e3055] to-navy opacity-60 pointer-events-none" data-id="element-27" />

      <div className="relative max-w-4xl mx-auto px-4 py-16 md:py-24 text-center" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-red/10 border border-red/30 rounded-full px-5 py-2 mb-8" data-id="element-30">
            <CircleIcon className="w-3 h-3 text-red fill-red" data-id="element-31" />
            <span className="text-red font-oswald text-sm tracking-wider uppercase font-semibold" data-id="element-32">
              Clase en vivo gratuita
            </span>
          </div>

          {/* Main Title */}
          <h1 className="font-oswald font-bold text-4xl md:text-6xl lg:text-7xl leading-tight mb-6 text-white uppercase" data-id="element-33">
            Crea Tu Página de Ventas
            <br data-id="element-34" />
            y Tus Creativos
            <br data-id="element-35" />
            <span className="text-red" data-id="element-36">en Un Día con IA</span>
          </h1>

          {/* Subtitle */}
          <p className="text-gray font-inter text-lg md:text-xl leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-37">
            Sin aparecer en cámara.
            <br data-id="element-38" />
            Sin experiencia previa.
            <br data-id="element-39" />
            Sin complicaciones.
          </p>

          {/* Date/Time Box */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-8 bg-red px-8 py-4 rounded-lg" data-id="element-40">
            <div className="flex items-center gap-2" data-id="element-41">
              <CalendarIcon className="w-5 h-5 text-white" data-id="element-42" />
              <span className="font-oswald font-semibold text-white text-base md:text-lg" data-id="element-43">
                Lunes 26 de Mayo 2026
              </span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-white/30" data-id="element-44" />
            <div className="flex items-center gap-2" data-id="element-45">
              <ClockIcon className="w-5 h-5 text-white" data-id="element-46" />
              <span className="font-oswald font-semibold text-white text-base md:text-lg" data-id="element-47">
                7:00 PM — Hora Colombia
              </span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}